// common
import React from 'react';
// icon
import { TfiClose } from 'react-icons/tfi';

import AdsConsentTerms from 'contents/terms/AdsConsentTerms';
import BilingPlanFreeTerms from 'contents/terms/BilingPlanFreeTerms';
import BilingPlanLiteTerms from 'contents/terms/BilingPlanLiteTerms';
import BilingPlanPremiumTerms from 'contents/terms/BilingPlanPremiumTerms';
import MarketingTerms from 'contents/terms/MarketingTerms';
import OptionalPrivacyTerms from 'contents/terms/OptionalPrivacyTerms';
import Over14Terms from 'contents/terms/Over14Terms';
import PartnershipTerms from 'contents/terms/PartnershipTerms';
import RequiredPrivacyTerms from 'contents/terms/RequiredPrivacyTerms';
import ServiceTerms from 'contents/terms/ServiceTerms';
import WithDrawalTerms from 'contents/terms/WithDrawalTerms';
import styled from 'styled-components';

import { TermContent } from 'components/form/TermsInfoField';
// components
import BaseModal from 'components/modal/BaseModal';

import useModal from 'hooks/components/useModal';

import { modal } from 'styles/commons/modal';

export const TermsModal = () => {
  const { visibleModal, closeModal } = useModal();

  const getTermsConfig = () => {
    switch (visibleModal.modalType) {
      // 회원 가입 - [필수] 만 14세 이상 동의
      case 'over14Terms':
        return { component: <Over14Terms /> };
      // 회원 가입 -[필수] INAVI Maps 이용약관 동의
      case 'serviceTerms':
        return { component: <ServiceTerms /> };
      // 회원 가입 -[필수] 개인정보 수집 동의
      case 'requiredPrivacyTerms':
        return { component: <RequiredPrivacyTerms /> };
      // 회원 가입 - [선택] 개인정보 수집 동의
      case 'optionalPrivacyTerms':
        return { component: <OptionalPrivacyTerms /> };
      // 회원 가입 - [선택] 마케팅 목적의 개인정보 수집 및 이용동의
      case 'marketingTerms':
        return { component: <MarketingTerms /> };
      // 회원 가입 - [선택] 광고성 정보 수신 동의
      case 'adsConsentTerms':
        return { component: <AdsConsentTerms /> };
      // 회원탈퇴 - INAVI Maps 회원 탈퇴 시 정보 삭제 범위
      case 'withdrawalTerms':
        return { component: <WithDrawalTerms /> };
      // 1:1 문의 - ㈜아이나비시스템즈 개인(위치)정보 처리방침
      case 'partnershipTerms':
        return {
          component: <PartnershipTerms />,
          width: '580px',
          height: '580px',
        };
      // 요금제 신청 - INAVI Maps 상품 이용약관_FREE(체험판)
      case 'bilingPlanfreeTerms':
        return { component: <BilingPlanFreeTerms /> };
      // 요금제 신청 - INAVI Maps_상품 이용약관_SMART100(정액제)
      case 'bilingPlanliteTerms':
        return { component: <BilingPlanLiteTerms /> };
      // 요금제 신청 - INAVI Maps 상품 이용약관_START(종량제)
      case 'bilingPlanpremiumTerms':
        return { component: <BilingPlanPremiumTerms /> };
      default:
        return null;
    }
  };

  const config = getTermsConfig();

  if (!config) return <></>;

  return (
    <TermsBaseModal
      visible={visibleModal.isopen}
      icon={<TfiClose />}
      width={config.width || '680px'}
      title={visibleModal.modalName}
      onClose={closeModal}
    >
      <TermContent height={config.height}>
        <TermContentBox>{config.component}</TermContentBox>
      </TermContent>
    </TermsBaseModal>
  );
};
const TermsBaseModal = styled(BaseModal)`
  ${modal.Header} {
    padding-top: 32px;
    padding-bottom: 16px;

    h2 {
      font-size: 20px;

      @media screen and (max-width: 768px) {
        font-size: 18px;
      }
    }

    .close_btn {
      top: 28px;
      transform: translateY(0);
      svg {
        fill: ${({ theme }) => theme.color.gray600};
      }
    }
  }
  ${modal.Content} {
    padding: 0;
    margin-bottom: 24px;

    @media screen and (max-width: 768px) {
      overflow: hidden;
    }
  }
`;

const TermContentBox = styled.div`
  padding: 12px 32px 32px;
  white-space: pre-wrap;
  font-size: 13px;
  line-height: 1.5;
  letter-spacing: normal;
  .sublist {
    margin-left: 15px;
  }

  @media screen and (max-width: 768px) {
    padding: 12px;
  }
`;
